import { Container } from "react-bootstrap";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { Typewriter } from "react-simple-typewriter";
import "./Banner.css";

const Banner = () => {
  return (
    <section id="banner">
      <Container>
        <div className="body">
          <div className="banner-copy">
            <p className="banner-kicker">
              <span /> Available for thoughtful digital work
            </p>
            <h1>
              Designing useful
              <br />
              <em>digital experiences.</em>
            </h1>
            <p className="banner-intro">
              Hi, I&apos;m <strong>Shoieb Alam</strong> — a developer who turns complex ideas into clear, responsive web
              applications.
            </p>

            <h5 className="role-line">
              <Typewriter
                words={["React JS Developer", "Web Application Developer", "MERN-Stack Developer"]}
                loop={5}
                cursor
                cursorStyle="_"
                typeSpeed={10}
                deleteSpeed={100}
                delaySpeed={1000}
              />
            </h5>

            <div className="banner-actions">
              <a
                className="btn-resume"
                href="https://drive.google.com/file/d/1s7dAJ0P7SgWr7vinJ_qyCUsIaHyKNv7s/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                View Resume <span aria-hidden="true">↗</span>
              </a>
              <span className="social-label">Find me online</span>
              <div className="social-links">
                <a
                  href="https://www.github.com/shoieb-dev"
                  className="social-icon"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="GitHub Profile"
                >
                  <FaGithub />
                </a>
                <a
                  href="https://www.linkedin.com/in/sa-dev"
                  className="social-icon"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn Profile"
                >
                  <FaLinkedin />
                </a>
              </div>
            </div>
          </div>

          <div className="banner-panel" data-aos="fade-left" data-aos-duration="1200">
            <div className="panel-topline">
              <span className="panel-dot" /> portfolio / {new Date().getFullYear()}
            </div>
            <div className="panel-mark">
              SA<span>.</span>
            </div>
            <p className="panel-note">
              A frontend-minded developer focused on fast, expressive interfaces and dependable product experiences.
            </p>
            <div className="panel-meta">
              <div>
                <span>Focus</span>
                <strong>Web applications</strong>
              </div>
              <div>
                <span>Based in</span>
                <strong>Bangladesh</strong>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Banner;
